import styled from 'styled-components';

import { token, spaceMixin } from '@zillow/constellation';

interface StyledIconProps {
    icon: string;
}

const StatusIcon = styled.span<StyledIconProps>`
    margin-right: ${spaceMixin(1)};
    flex-shrink: 0;
    font-size: 10px;
    height: 1em;
    width: 1em;
    border-radius: ${token('radii.ellipse')};
    display: inline-block;
    background-color: ${(props) => {
        switch (props.icon) {
            case 'zsg-icon-for-sale':
                return token('colors.forSale');
            case 'zsg-icon-for-rent':
                return token('colors.forRent');
            case 'zsg-icon-pre-market':
                return token('colors.comingSoon');
            case 'zsg-icon-recently-sold':
                return token('colors.recentlySold');
            case 'zsg-icon-off-market':
                return token('colors.offMarket');
            default:
                return token('colors.offMarket');
        }
    }};
`;

export default StatusIcon;
